import React, {PropTypes} from 'react';
import {dateComparator} from 'shared/util/dateComparator';
import ScheduleSquadListItem from './ScheduleSquadListItem.jsx';

const ScheduleSquadList = ({
  source,
  onQuantityChange,
  onAddClick,
  onSquadFeesClick,
  onNextDateClick
}) => (
  <div className="list-group">
    {source.sort(dateComparator('startDateTime'))
      .map((squad, index) =>
      <ScheduleSquadListItem
        key={index}
        {...squad}
        onAddClick={onAddClick}
        onFeesClick={onSquadFeesClick}
        onQuantityChange={onQuantityChange}
        onNextDateClick={onNextDateClick}
      />
    )}
  </div>
);

ScheduleSquadList.propTypes = {
  source: PropTypes.arrayOf(PropTypes.object),
  onQuantityChange: PropTypes.func,
  onAddClick: PropTypes.func,
  onSquadFeesClick: PropTypes.func,
  onNextDateClick: PropTypes.func
};

ScheduleSquadList.defaultProps = {
  source: []
};

export default ScheduleSquadList;



// WEBPACK FOOTER //
// ./src/features/shared/ScheduleSquadList.jsx